import React, { useContext } from 'react';
import { DestinationContext } from '../../../contexts/DestinationContext';
import styles from './SafariIdeas.module.scss';

const parseDays = (duration = '') => {
  const match = duration.match(/\d+/);
  return match ? Number(match[0]) : null;
};

const parsePrice = (price = '') => {
  const match = price.match(/[\d,]+/);
  return match ? Number(match[0].replace(/,/g, '')) : null;
};

const SafariIdeas = ({ onOpenPlanner }) => {
  const destination = useContext(DestinationContext);
  const safariIdeas = destination?.safariIdeas;
  const isObjectFormat = safariIdeas && !Array.isArray(safariIdeas);
  const ideas = isObjectFormat ? safariIdeas.ideas || [] : safariIdeas || [];
  const images = destination?.images?.safari || [];

  if (ideas.length === 0) return null;

  const handleGetQuote = (idea, imageUrl) => {
    onOpenPlanner?.({
      numberOfDays: parseDays(idea.duration),
      pricePerPerson: parsePrice(idea.price),
      destination,
      duration: idea.duration,
      title: idea.title,
      route: idea.route,
      image: imageUrl,
    });
  };

  const eyebrow = isObjectFormat && safariIdeas.eyebrow ? safariIdeas.eyebrow : "Need Inspiration?";
  const title = isObjectFormat && safariIdeas.title ? safariIdeas.title : `Safari <span class="${styles.accent}">Ideas</span>`;
  const subtext = isObjectFormat && safariIdeas.subtext ? safariIdeas.subtext : "Ready-made itineraries to spark your trip — tell us which you like and operators will tailor it to you.";

  return (
    <section className={styles.section}>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <div className={styles.eyebrow}>{eyebrow}</div>
          <h2 className={styles.heading} dangerouslySetInnerHTML={{ __html: title }} />
          <p className={styles.lead}>{subtext}</p>
        </div>
        <div className={styles.ideas}>
          {ideas.map((idea, i) => {
            const fallbackImage = images[i % images.length] || images[0];
            const imageUrl = idea.image || fallbackImage?.url;
            return (
              <div
                className={styles.idea}
                key={idea.title || i}
                role="button"
                tabIndex={0}
                onClick={() => handleGetQuote(idea, imageUrl)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleGetQuote(idea, imageUrl);
                  }
                }}
              >
                <div className={styles.media}>
                  {imageUrl && (
                    <img
                      src={imageUrl}
                      alt={idea.title}
                      loading="lazy"
                      decoding="async"
                    />
                  )}
                  <div className={styles.overlay}>
                    {idea.duration && <span className={styles.days}>{idea.duration}</span>}
                    <h3>{idea.title}</h3>
                    {idea.route && <div className={styles.meta}>{idea.route}</div>}
                    <span className={styles.cta}>Get a Quote →</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SafariIdeas;
